(() => {
  if (window.__snapLockHardEightInchFitPolicy) return;
  window.__snapLockHardEightInchFitPolicy = true;

  const replacements = [
    ['Small: 38–42mm · wrists to 7.8" Large: 44–49mm · recommended up to 8.0"', 'Small: 38–42mm · wrists to 7.8" Large: 44–49mm · wrists to 8.0"'],
    ['Small: 38–42 mm, wrists up to 198 mm · Large: 44–49 mm, recommended up to 203 mm', 'Small: 38–42 mm, wrists up to 198 mm · Large: 44–49 mm, wrists up to 203 mm'],
    ['Pequeña: 38–42 mm, muñecas de hasta 7,8 pulg. · Grande: 44–49 mm, recomendado hasta 8,0 pulg.', 'Pequeña: 38–42 mm, muñecas de hasta 7,8 pulg. · Grande: 44–49 mm, muñecas de hasta 8,0 pulg.'],
    ['Pequeña: 38–42 mm, muñecas de hasta 198 mm · Grande: 44–49 mm, recomendado hasta 203 mm', 'Pequeña: 38–42 mm, muñecas de hasta 198 mm · Grande: 44–49 mm, muñecas de hasta 203 mm'],
    ['44, 45, 46, or 49mm Apple Watch · Recommended up to 8.0 in (203mm)', '44, 45, 46, or 49mm Apple Watch · Fits wrists up to 8.0 in (203mm)'],
    ['44 / 45 / 46 / 49mm · Recommended up to 8.0 in (203mm)', '44 / 45 / 46 / 49mm · Fits wrists up to 8.0 in (203mm)'],
    ['44, 45, 46, or 49mm Apple Watch · Recommended up to 203mm', '44, 45, 46, or 49mm Apple Watch · Fits wrists up to 203mm'],
    ['Apple Watch de 44, 45, 46 o 49 mm · Recomendado hasta 8,0 pulg. (203 mm)', 'Apple Watch de 44, 45, 46 o 49 mm · Para muñecas de hasta 8,0 pulg. (203 mm)'],
    ['Apple Watch de 44, 45, 46 o 49 mm · Recomendado hasta 203 mm', 'Apple Watch de 44, 45, 46 o 49 mm · Para muñecas de hasta 203 mm'],
    ['Recommended up to 8.0 in / 203mm', 'Up to 8.0 in / 203mm'],
    ['Recomendado hasta 8,0 pulgadas / 203 mm', 'Hasta 8,0 pulgadas / 203 mm'],
    ['Large can fit wrists up to 8.3 in (210mm). For the most secure magnetic overlap, we recommend 8.0 in (203mm) or less.', 'Large fits wrists up to 8.0 in (203mm). SnapLock Large is not recommended for wrists over 8.0 in (203mm).'],
    ['Large can fit wrists up to 210mm. For the most secure magnetic overlap, we recommend 203mm or less.', 'Large fits wrists up to 203mm. SnapLock Large is not recommended for wrists over 203mm.'],
    ['Grande: hasta 8,3 pulg. (210 mm); para mantener la superposición magnética más segura, recomendamos aproximadamente 8 pulg. (203 mm) o menos.', 'Grande: hasta 8,0 pulg. (203 mm). No recomendamos SnapLock Grande para muñecas de más de 8,0 pulg. (203 mm).'],
    ['Grande puede ajustarse hasta 210 mm. Para mantener la superposición magnética más segura, recomendamos 203 mm o menos.', 'Grande: hasta 203 mm. No recomendamos SnapLock Grande para muñecas de más de 203 mm.'],
    ['Large fits wrists up to 8.3 in (210mm). For secure magnetic overlap, we recommend 8.0 in (203mm) or less.', 'Large fits wrists up to 8.0 in (203mm). SnapLock Large is not recommended for wrists over 8.0 in (203mm).'],
    ['Recommended up to 8.0 in (203mm). Maximum: 8.3 in (210mm).', 'Fits wrists up to 8.0 in (203mm).'],
    ['Recomendado hasta 8,0 pulgadas (203 mm). Máximo: 8,3 pulgadas (210 mm).', 'Para muñecas de hasta 8,0 pulgadas (203 mm).'],
    ['Large: recommended up to 8.0 in (203mm), with a maximum of 8.3 in (210mm).', 'Large: up to 8.0 in (203mm).'],
    ['Grande: recomendado hasta 8,0 pulgadas (203 mm), máximo 8,3 pulgadas (210 mm).', 'Grande: hasta 8,0 pulgadas (203 mm).']
  ];

  const rewrite = (value) => {
    if (!value) return value;
    let next = value;
    replacements.forEach(([from, to]) => {
      if (next.includes(from)) next = next.split(from).join(to);
    });
    return next;
  };

  const enforce = () => {
    const root = document.querySelector('#MainContent') || document.body;
    if (!root) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const next = rewrite(node.nodeValue);
      if (next !== node.nodeValue) node.nodeValue = next;
    }

    root.querySelectorAll('[data-large-wrist]').forEach((element) => {
      const value = element.getAttribute('data-large-wrist');
      const next = rewrite(value);
      if (next !== value) element.setAttribute('data-large-wrist', next);
    });

    root.querySelectorAll('.sl-size-guide__wrist-warning').forEach((element) => {
      if (element.textContent.trim()) element.textContent = '';
      element.hidden = true;
    });
  };

  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      enforce();
    });
  };

  const start = () => {
    enforce();
    const root = document.querySelector('#MainContent') || document.body;
    if (!root) return;
    const observer = new MutationObserver(schedule);
    observer.observe(root, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['data-large-wrist']
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
